import { useContext } from "react";
import { Context } from "../../../context/Context";
import { translations } from "../../../utils/lang";
import {
  CheckCircle,
  CircleCheckBig,
  CircleStop,
  Clock3,
  Loader,
  Trash2,
  XCircle,
} from "../../ui";
import "./CampaignActions.css";

const ICONS = {
  pending: Clock3,
  inprogress: Loader,
  active: CheckCircle,
  completed: CircleCheckBig,
  rejected: XCircle,
  canceled: CircleStop,
  deleted: Trash2,
};

// The status exactly as the API returned it: an icon, a colour and a label
// together (never colour alone). Unknown values are shown as received.
export default function StatusBadge({ status, className = "" }) {
  const { lang } = useContext(Context);
  if (!status) return null;
  const Icon = ICONS[status];
  const label = translations[lang].Operation.status[status] || status;
  return (
    <span
      className={`ca-status action-${status} ${className}`}
      data-status={status}
    >
      {Icon && <Icon size={14} aria-hidden="true" />}
      <span>{label}</span>
    </span>
  );
}
